import Typography from "@mui/material/Typography";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import Button from "@mui/material/Button";
import check from "Benchmarking/Assets/check.png";
import { Tag } from "antd";
import { useNavigate } from "react-router-dom";
import { numberRegex } from "Benchmarking/Config/UtilFunction";
import { LoadingList } from "./LoadingComponent";

export const InstitutionScholars = ({ data }) => {
  const Scholar = ({ scholar }) => {
    const navigate = useNavigate();
    return (
      <div className="scholar">
        <div className="avatar">
          <img
            src={
              scholar.photo
                ? scholar.photo
                : "https://s3.us-east-2.amazonaws.com/academic.online/default_photos/default_faculty_photo.png"
            }
            alt="avatar"
            className="photo"
          />
          {scholar.verified && (
            <img src={check} alt="check" className="check" />
          )}
        </div>
        <div className="info">
          <div
            onClick={() => {
              navigate(`/benchmarking/faculty/profile/${scholar.id}`);
            }}
          >
            <p className="name">{scholar.name}</p>
          </div>
          {/* <p className="inst-name">{scholar.department.inst_name}</p> */}
          <p className="position">{scholar.position}</p>
          <div className="tags">
            {scholar.keywords.map((item, index) => {
              return (
                <Tag
                  key={index}
                  color="var(--light-blue)"
                  style={{ cursor: "pointer" }}
                >
                  {item.id}
                </Tag>
              );
            })}
          </div>
          {scholar.citation_count != 0 && (
            <Button
              style={{
                backgroundColor: "white",
                color: "#b45f06",
                borderRadius: 10,
                height: 25,
                paddingLeft: 0,
                textAlign: "left",
                textTransform: "none",
                marginRight: "10px",
              }}
            >
              <FormatQuoteIcon />
              <Typography align={"left"} style={{ fontSize: 12 }}>
                {numberRegex(scholar.citation_count)}
              </Typography>
            </Button>
          )}
          {/* <FeedBackButton /> */}
        </div>
      </div>
    );
  };
  return (
    <div className="institution-scholars">
      <LoadingList
        data={data}
        avatar={true}
        rows={2}
        component={data?.map((item, index) => {
          return <Scholar key={index} scholar={item} />;
        })}
      />
    </div>
  );
};

export const InstitutionPublications = ({ data }) => {
  const Publication = ({ publication }) => {
    return (
      <div className="publication">
        <div className="title">
          <span className="paper-title">{publication.title}. </span>
          <span className="venue">
            <i>{publication.venue} </i>
          </span>
          <span>{publication.year > 0 ? `(${publication.year})` : ""}</span>
        </div>
        <div className="coauthors">
          {publication.coauthors.map((item, index) => {
            return <span key={index}>{item.name}</span>;
          })}
        </div>
        <div className="tags">
          {publication.keywords.map((item, index) => {
            return (
              <Tag
                key={index}
                color="var(--light-blue)"
                style={{ cursor: "pointer" }}
              >
                {item.id}
              </Tag>
            );
          })}
        </div>
        <div className="action">
          {publication.num_citations != 0 && (
            <Button
              style={{
                backgroundColor: "white",
                color: "#b45f06",
                borderRadius: 10,
                height: 25,
                paddingLeft: 0,
                textAlign: "left",
                textTransform: "none",
                marginRight: "10px",
              }}
            >
              <FormatQuoteIcon />
              <Typography align={"left"} style={{ fontSize: 12 }}>
                {publication["num_citations"]}
              </Typography>
            </Button>
          )}
          {/* <FeedBackButton /> */}
        </div>
      </div>
    );
  };
  return (
    <div className="faculty-publications">
      <LoadingList
        data={data}
        rows={4}
        component={data?.map((item, index) => {
          return <Publication publication={item} key={index} />;
        })}
      />
    </div>
  );
};
